import { render } from "./moduleConfig.vue?vue&type=template&id=9d217072&scoped=true"
import script from "./moduleConfig.vue?vue&type=script&lang=js"
export * from "./moduleConfig.vue?vue&type=script&lang=js"

import "./moduleConfig.vue?vue&type=style&index=0&id=9d217072&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d217072"]])

export default __exports__